export const FETCH_ROLEINFO_INIT = "FETCH_ROLEINFO_INIT";
export const INIT_CREATE_ROLE_SCREEN = "INIT_CREATE_ROLE_SCREEN";

export const FETCH_ROLES_LIST = {
  START: "FETCH_ROLES_LIST_START",
  SUCCESS: "FETCH_ROLES_LIST_SUCCESS",
  ERROR: "FETCH_ROLES_LIST_ERROR",
};

export const FETCH_ROLE_DETAIL = {
  START: "FETCH_ROLE_DETAIL_START",
  SUCCESS: "FETCH_ROLE_DETAIL_SUCCESS",
  ERROR: "FETCH_ROLE_DETAIL_ERROR",
};

export const FETCH_ROLE_MENU_ACCESS = {
  START: "FETCH_ROLE_MENU_ACCESS_START",
  SUCCESS: "FETCH_ROLE_MENU_ACCESS_SUCCESS",
  ERROR: "FETCH_ROLE_MENU_ACCESS_ERROR",
};

export const UPDATE_ROLE = {
  START: "UPDATE_ROLE_START",
  SUCCESS: "UPDATE_ROLE_SUCCESS",
  ERROR: "UPDATE_ROLE_ERROR",
};

export const CREATE_ROLE = {
  START: "CREATE_ROLE_START",
  SUCCESS: "CREATE_ROLE_SUCCESS",
  ERROR: "CREATE_ROLE_ERROR",
};

export const FETCH_ALL_MENUS = {
  START: "FETCH_ALL_MENUS_START",
  SUCCESS: "FETCH_ALL_MENUS_SUCCESS",
  ERROR: "FETCH_ALL_MENUS_ERROR",
};

export const DELETE_ROLE = {
  START: "DELETE_ROLE_START",
  SUCCESS: "DELETE_ROLE_SUCCESS",
  ERROR: "DELETE_ROLE_ERROR",
};

export const TOAST = {
  RESET: "RESET_ROLE_TOAST",
};

export const ROLE_SAVE_TABLE_STATE = "ROLE_SAVE_TABLE_STATE";

export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY = "SET_ROLE_DELETE_CONFIRMATION_POPUP_VISIBILITY";
